import createReducer from '../../utils/createReducer';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  campaignId: null,
  requesting: false,
  error: null,
  removingId: 0,
  removeError: null,
  publishResult: null,
};

const campaign = createReducer(initialState, {
  // create campaign
  [actionTypes.CAMPAIGN_CREATE_REQUEST](state) {
    return { ...state, requesting: true, error: null };
  },
  [actionTypes.CAMPAIGN_CREATE_ERROR](state, { payload }) {
    return { ...state, error: payload, requesting: false };
  },
  [actionTypes.CAMPAIGN_CREATE_SUCCESS](state, { payload }) {
    return {
      ...state,
      campaignId: payload,
      requesting: false,
      error: null,
    };
  },
  // remove campaign
  [actionTypes.CAMPAIGN_REMOVE_REQUEST](state, { payload }) {
    return { ...state, removingId: payload.id, removeError: null };
  },
  [actionTypes.CAMPAIGN_REMOVE_ERROR](state, { payload }) {
    return { ...state, removeError: payload, removingId: 0 };
  },
  [actionTypes.CAMPAIGN_REMOVE_SUCCESS](state) {
    return { ...state, removingId: 0, removeError: null };
  },
  // publish campaign
  [actionTypes.CAMPAIGN_PUBLISH_REQUEST](state) {
    return { ...state, requesting: true, error: null };
  },
  [actionTypes.CAMPAIGN_PUBLISH_ERROR](state, { payload }) {
    return { ...state, error: payload, requesting: false };
  },
  [actionTypes.CAMPAIGN_PUBLISH_SUCCESS](state, { payload }) {
    return {
      ...state,
      publishResult: payload,
      requesting: false,
      error: null,
    };
  },
  // reset state
  [actionTypes.CAMPAIGN_RESET_STATE]() {
    return initialState;
  },
});

export default campaign;

export const getCampaignId = (state) => state.campaign.campaignId;
export const getIsRequesting = (state) => state.campaign.requesting;
export const getIsIntegrationsRequesting = (state) => state.integrations.requesting;
export const getError = (state) => state.campaign.error;
export const getRemovingId = (state) => state.campaign.removingId;
export const getRemoveError = (state) => state.campaign.removeError;
export const getPublishResult = (state) => state.campaign.publishResult;
